import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserExperienceState {
  isLoading: boolean;
  // TODO: Convert this to be by user ID
  userExperiences: any[];
}

const USER_EXPERIENCE_INITIAL: UserExperienceState = {
  userExperiences: [],
  isLoading: false,
};

const userExperienceSlice = createSlice({
  name: "userExperience",
  initialState: {
    ...USER_EXPERIENCE_INITIAL,
  },
  reducers: {
    USER_EXPERIENCE_UPDATE_BULK: (
      state,
      action: PayloadAction<{
        data: any[];
      }>,
    ) => {
      return (state = {
        ...state,
        userExperiences: [...(action?.payload?.data ?? [])],
      });
    },
    USER_EXPERIENCE_UPDATE_SINGLE: (
      state,
      action: PayloadAction<{
        data?: any;
      }>,
    ) => {
      return (state = {
        ...state,
        userExperiences: [...(state.userExperiences ?? []), ...(action.payload.data ? [action.payload.data] : [])],
      });
    },
  },
});

const { USER_EXPERIENCE_UPDATE_BULK, USER_EXPERIENCE_UPDATE_SINGLE } = userExperienceSlice.actions;

export { userExperienceSlice, USER_EXPERIENCE_INITIAL, USER_EXPERIENCE_UPDATE_BULK, USER_EXPERIENCE_UPDATE_SINGLE };
